import type { ApolloClient, Reference } from '@apollo/client';

import type { ChatEventFragment } from '@spotify/confidence-graphql';

import { CHAT_EVENTS_ORDER_BY } from './useCachedChatEvents/useCachedChatEvents';

export const insertChatEventIntoCache = (
  client: ApolloClient<unknown>,
  chatName: string,
  event: { name: string } & Record<string, unknown>,
): void => {
  if (!event.name) return;

  client.cache.modify({
    id: 'ROOT_QUERY',
    fields: {
      chatEvents(existing = {}, { storeFieldName, readField, toReference }) {
        const expectedParentToken = `"parent":"${chatName}"`;
        if (!storeFieldName.includes(expectedParentToken)) {
          return existing;
        }

        if (!storeFieldName.includes(`"orderBy":"${CHAT_EVENTS_ORDER_BY}"`)) {
          return existing;
        }

        const existingEvents: Reference[] = Array.isArray(existing.chatEvents)
          ? existing.chatEvents
          : [];

        if (
          existingEvents.some(
            (ref: Reference) => readField('name', ref) === event.name,
          )
        ) {
          return existing;
        }

        const newRef = toReference(event as ChatEventFragment);
        if (!newRef) return existing;

        return {
          ...existing,
          __typename:
            existing.__typename ?? 'ConversationsV2ListChatEventsResponse',
          chatEvents: [newRef, ...existingEvents],
        };
      },
    },
  });
};
